<template>
  <div class="i-resource-card">
    <div
      class="card"
      @click="ctaAction()"
    >
      <img
        class="top"
        :src="image"
      />
      <div class="bottom">
        <div class="wrap">
          <div
            class="tag"
            :style="{ backgroundColor: color }"
          >
            {{ tag }}
          </div>
          <div class="title">{{ title }}</div>
          <div class="info">{{ info }}</div>
        </div>
        <div class="fake-cta">{{ ctaText }} <img :src="iconChevron" /></div>
      </div>
    </div>
    <iOnboardingTooltip
      v-if="isFirst"
      :value="6"
    />
  </div>
</template>

<script setup lang="ts">
import iOnboardingTooltip from "@/components/report/OnboardingTooltip.vue"

// ASSETS
import iconChevron from "@/assets/icons/icon-blue-arrow-right.svg"

defineProps({
  title: {
    type: String,
    required: true
  },
  info: {
    type: String,
    required: true
  },
  image: {
    type: String,
    required: true
  },
  ctaText: {
    type: String,
    required: true
  },
  ctaAction: {
    type: Function,
    required: true
  },
  tag: {
    type: String,
    required: true
  },
  isFirst: {
    type: Boolean,
    required: true
  },
  color: {
    type: String,
    required: true
  }
})
</script>

<style scoped lang="scss">
.i-resource-card {
  position: relative;

  .card {
    @include border-radius-lg;
    @include grid($cols: 1fr, $rows: 200px auto, $align-items: stretch);

    border: 1px solid $zumthor100;
    height: 100%;
    cursor: pointer;
    background-color: $white;

    @media screen and (min-width: $breakpoint-md) {
      grid-template-rows: 230px auto;
    }

    .top {
      width: 100%;
      object-fit: cover;
      object-position: top;
      border-top-left-radius: 24px;
      border-top-right-radius: 24px;
      border-bottom: 1px solid $zumthor100;
    }

    &:hover {
      background-color: $azure-radiance50;
      border: 1px solid $azure-radiance200;

      .fake-cta,
      .tag,
      .top {
        filter: brightness(85%);
      }
    }

    .bottom {
      @include flex(column, space-between, stretch, $gap: 15px);

      padding: 15px;
      border-bottom-left-radius: 24px;
      border-bottom-right-radius: 24px;

      @media screen and (min-width: $breakpoint-sm) {
        padding: 20px;
      }

      .wrap {
        @include flex(column, start, stretch, $gap: 5px);

        .tag {
          width: fit-content;
          background-color: var(--bg-color);
          color: $black400;
          padding: 3px 8px;
          margin-bottom: 5px;

          @include border-radius-sm;
          @include text-xs;
        }

        .title {
          @include text-lg;

          font-weight: 700;
          min-height: 45px;

          @media screen and (min-width: $breakpoint-lg) {
            @include text-xl;
          }
        }

        .info {
          @include text-md;

          margin-bottom: 28px;

          @media screen and (min-width: $breakpoint-sm) {
            margin-bottom: 10px;
          }
        }
      }

      .fake-cta {
        @include flex(row, space-between, center);

        color: $azure-radiance500;
        font-weight: 500;
      }
    }
  }
}
</style>
